/**
 * 历史支出常把支票号只写在备注里，编辑时可补入空白号码栏，避免重复抄写。
 * 只识别明确的中英文支票号标签；日期、金额和导入标识不能当作支票号。
 * 返回唯一的数字号码（保留前导零）；多号或格式不明确时返回空串，留给用户核对。
 */
export function extractCheckNumberFromNote(note) {
  const text = String(note || "").normalize("NFKC");
  const labels = /支票(?:号码|编号|号)|\b(?:check|cheque)\s*(?:number\b|no\b\.?|#)/gi;
  const numbers = new Set();
  for (const match of text.matchAll(labels)) {
    const tail = text.slice(match.index + match[0].length).replace(/^\s*[:=#]?\s*/, "");
    // 本次需求只自动提取公司使用的四位支票号；其他长度仍可手动输入，已登记的号码不改写。
    const number = tail.match(/^([0-9]{4})(?![0-9])/);
    if (!number) return "";
    const suffix = tail.slice(number[0].length);
    // 不截取日期、金额、字母号码或“2985 / 2986”中的一部分，财务号码宁缺勿误。
    if (/^[A-Za-z0-9./-]|^\s*[/+&、-]|^\s*[,，.]\s*[0-9]/.test(suffix)) return "";
    numbers.add(number[1]);
  }
  return numbers.size === 1 ? [...numbers][0] : "";
}

/** 从备注中的明确发票号标签提取唯一四位号码，保留前导零。 */
export function extractInvoiceNumberFromNote(note) {
  const text = String(note || "").normalize("NFKC");
  const labels = /发票(?:号码|编号|号)|\binvoice\s*(?:number\b|no\b\.?|#)/gi;
  const numbers = new Set();
  for (const match of text.matchAll(labels)) {
    const tail = text.slice(match.index + match[0].length).replace(/^\s*[:=#]?\s*/, "");
    const number = tail.match(/^([0-9]{4})(?![0-9])/);
    if (!number) return "";
    const suffix = tail.slice(number[0].length);
    if (/^[A-Za-z0-9./-]|^\s*[/+&、-]|^\s*[,，.]\s*[0-9]/.test(suffix)) return "";
    numbers.add(number[1]);
  }
  return numbers.size === 1 ? [...numbers][0] : "";
}
